import { useEffect } from 'react';

/**
 * Quiz raster URLs resolved at build time by Vite's glob.
 * Paths are project-root-absolute (`@` is not supported inside glob patterns).
 */
const QUIZ_IMAGE_URLS = Object.values(
  import.meta.glob('/src/features/quiz/assets/**/*.{webp,png,jpg}', {
    eager: true,
    query: '?url',
    import: 'default',
  }),
) as string[];

/** Keep Image handles alive so in-flight downloads aren't GC'd mid-warm. */
let warmedImages: HTMLImageElement[] | null = null;

/**
 * Warm quiz step / background images into the browser cache.
 * Call from the quiz entry (and optionally late onboarding) so each step
 * no longer flash-loads its image on entry.
 */
export function usePreloadQuizImages() {
  useEffect(() => {
    if (warmedImages) return;
    warmedImages = QUIZ_IMAGE_URLS.map((src) => {
      const img = new Image();
      img.src = src;
      return img;
    });
  }, []);
}
